import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import TOOLS from '../../componentes/TOOLS';

import '../css/ListaAppsItem.css';

class ListaAppsItem extends Component {
    constructor() {
        super();
        this.state = {};
    }

    handleRemoveApp(e) {
        e.preventDefault();

        if (window.confirm(`Deseja Remover o Aplicativo (${this.props.app.id})?`)) {
            this.props.callBackRemoveApp(this.props.app.id);
        }
    }

    handleViewApp(e){
        e.preventDefault();

        window.open(`${TOOLS.siteURL}/app/${this.props.app.id}`);
    }

    componentWillMount() {

    }

    render() {
        return (
            <div className="listaAppItens">
                <div className="listaAppItens-icone">
                    <img src={this.props.app.icon} alt="icon" />
                </div>
                <div className="listaAppItens-actions">
                    <Link to={`/adm/app/${this.props.app.id}`}><i className="fas fa-edit"></i></Link>
                    <a href="/" onClick={this.handleViewApp.bind(this)} ><i className="fas fa-eye"></i></a>
                    <a href="/" onClick={this.handleRemoveApp.bind(this)} ><i className="fas fa-trash"></i></a>
                </div>
            </div>
        );
    }
}

export default ListaAppsItem;



// WEBPACK FOOTER //
// ./src/adm/componentes/ListaAppsItem.js